import { ICON_PLATFORM_COLOR } from '@/constants/icons';
import { Platform, PlatformItem } from '@/types';
import { getIcon } from '@/utils/imageUtils';

export const PlatformsData: Record<Platform, PlatformItem> = {
  [Platform.MOBILE]: {
    name: Platform.MOBILE,
    icon: getIcon(
      `${Platform.MOBILE}_ico-${ICON_PLATFORM_COLOR}.svg`,
      'platforms',
      Platform.MOBILE,
    ),
  },
  [Platform.DESKTOP]: {
    name: Platform.DESKTOP,
    icon: getIcon(
      `${Platform.DESKTOP}_ico-${ICON_PLATFORM_COLOR}.svg`,
      'platforms',
      Platform.DESKTOP,
    ),
  },
};
